import { useMutation } from '@tanstack/react-query';
import postStudioAvalaibility from 'Api/studio/postStudioAvailability';

import postStudioAvailabilityPayload from './model/request/postStudioAvailabilityPayload';

const usePostStudioAvailability = (setError) => {
  return useMutation({
    mutationFn: async (formData) => {
      const payload = postStudioAvailabilityPayload(formData);

      const response = await postStudioAvalaibility({ payload });

      return response;
    },

    onError: (error) => {
      const errorFields = error?.response?.data?.errorFields;

      if (errorFields?.name) setError('name', { type: 'custom', message: errorFields?.name?.message || '' });
    },
  });
};

export default usePostStudioAvailability;
